import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { INSTAGRAM_BIND_MODAL } from "../../../../constants/modal.constant";
import { INSTAGRAM_SYNC_LOADING } from "../../../../constants/loading.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useInstagramCore } from "../../../../cores/instagram";
import { InstagramAccount } from "../../../../cores/instagram/interface/api/get-instagram-accounts";
import { useMeCore } from "../../../../cores/me";
import { useIntl } from "react-intl";
import InstagramAccounts from "./InstagramAccounts";
import { InstagramIcon } from "./InstagramIcon";
import { INSTAGRAM_COLOR } from "../../../../constants/socialColors.constant";

export default function InstagramLoginForm({
  accessToken,
}: {
  accessToken: string;
}) {
  const intl = useIntl();
  const { turnOffModal, isModal, isLoading } = useGlobalCore();
  const { bind, errorCode, settings } = useInstagramCore();
  const { company } = useMeCore();
  const [account, setAccount] = useState<InstagramAccount | null>(null);
  const binding = isLoading(INSTAGRAM_SYNC_LOADING);

  useEffect(() => {
    if (!isModal(INSTAGRAM_BIND_MODAL)) return;
    if (errorCode) return;
    if (!_.isEmpty(settings)) turnOffModal(INSTAGRAM_BIND_MODAL);
  }, [errorCode, isModal, settings, turnOffModal]);

  const handleBind = useCallback(
    async (selected: InstagramAccount) => {
      if (!company?.id) return;
      setAccount(selected);
      await bind(company.id, selected, "", accessToken);
    },
    [bind, company, accessToken]
  );

  return (
    <div className="p-4">
      <div className="text-center mb-3">
        <InstagramIcon size="4x" color={INSTAGRAM_COLOR} className="mb-2" />
        <h2 className="h5 mb-0">
          {intl.formatMessage({ id: "app.syncInstagram.title" })}
        </h2>
      </div>
      <InstagramAccounts
        onSelectAccount={setAccount}
        selectedAccount={account}
        onBindAccount={handleBind}
        binding={binding}
      />
    </div>
  );
}
